import Icon from './Icon';
import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const VARIANT_CLASS = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost',
    danger: 'btn-danger',
    'danger-soft': 'btn-danger-soft',
    success: 'btn-success',
    link: 'btn-link',
};

const SIZE_CLASS = { sm: 'btn-sm', md: '', lg: 'btn-lg' };

export const buttonClassName = ({ variant = 'primary', size = 'md', block = false, loading = false, iconOnly = false, className = '' } = {}) => (
    [
        'btn',
        VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
        SIZE_CLASS[size],
        block && 'btn-block',
        loading && 'btn-loading',
        iconOnly && 'btn-icon',
        className,
    ].filter(Boolean).join(' ')
);

/** `to` renders a router link with button styling. `loading` also disables and announces busy. */
const Button = forwardRef(({
    variant,
    size,
    block,
    loading = false,
    iconOnly,
    icon = null,
    to,
    type = 'button',
    disabled = false,
    className,
    children,
    ...rest
}, ref) => {
    const classes = buttonClassName({ variant, size, block, loading, iconOnly, className });
    const content = (
        <>
            {icon && <Icon name={icon} />}
            {children}
        </>
    );

    if (to && !disabled) {
        return <Link ref={ref} to={to} className={classes} {...rest}>{content}</Link>;
    }

    return (
        <button
            ref={ref}
            type={type}
            className={classes}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            {...rest}
        >
            {content}
        </button>
    );
});

Button.displayName = 'Button';

export default Button;
